import React, { useState, useEffect, useRef, useCallback } from 'react';
import classNames from 'classnames';

// Nuevo metodo de llamada a Backend
import { useAuth } from '../context/AuthContext';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';

import { SucursalService } from '../services/SucursalService';

import { UsuarioEntity } from '../entity/UsuarioEntity';
import PageHeader from '../components/ui/PageHeader';
import DialogHeader from '../components/ui/DialogHeader';
import ActionToolbar from '../components/ui/ActionToolbar';
import './Usuario.css';

export const Usuario = () => {

    let empty = { ...UsuarioEntity, role: null, tipoDocumento: 'DNI', apellidoPaterno: '', apellidoMaterno: '' };

    const { user, axiosInstance, logout } = useAuth();


    const [data, setData] = useState([]);
    // ...

    // ...

    const [totalRecords, setTotalRecords] = useState(0);



    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0
    });
    const [EntidadNewDialog, setEntidadNewDialog] = useState(false);

    const [product, setProduct] = useState(empty);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const [roles, setRoles] = useState([]);
    const [rolesLoaded, setRolesLoaded] = useState(false);

    const [sucursales, setSucursales] = useState([]);
    const [sucursalesLoaded, setSucursalesLoaded] = useState(false);

    const fetchSucursales = useCallback(async () => {
        if (sucursalesLoaded) return;
        try {
            const res = await SucursalService.getAll();
            const data = (res.data || res.items || []);
            setSucursales(data.map(sucursal => ({
                label: sucursal.nombre,
                value: sucursal.id
            })));
            setSucursalesLoaded(true);
        } catch (error) {
            console.error("Error al cargar sucursales", error);
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar sucursales', life: 3000 });
            }
        }
    }, [sucursalesLoaded]);

    const mapUserFromApi = (u) => ({
        ...u,
        password: '', // CRÍTICO: Prevenir que la API inyecte el hash cifrado actual en el formulario para evitar doble hash al guardar
        docIdentidad: u.docIdentidad || u.numeroDocumento || '',
        apellidoPaterno: u.apellidoPaterno || '',
        apellidoMaterno: u.apellidoMaterno || '',
        role: u.role || u.profile?.name || null,
        idSucursal: u.idSucursal || null
    });

    const fetchRoles = useCallback(async () => {
        if (rolesLoaded) return;
        try {
            const response = await axiosInstance.get('/api/admin/profiles/');
            // Ordenar por jerarquía: Super Admin primero, luego el resto por nivel descendente
            const sortedRoles = response.data.sort((a, b) => {
                if (a.name === 'SUPER_ADMINISTRADOR') return -1;
                if (b.name === 'SUPER_ADMINISTRADOR') return 1;
                return (b.hierarchyLevel || 0) - (a.hierarchyLevel || 0);
            });

            const mappedRoles = sortedRoles.map(role => ({
                label: role.name
                    .replace(/_/g, ' ')
                    .toLowerCase()
                    .replace(/\b\w/g, c => c.toUpperCase()), // Title Case Format
                value: role.name,
                id: role.id
            }));
            setRoles(mappedRoles);
            setRolesLoaded(true);
        } catch (error) {
            console.error("Error fetching roles:", error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los roles.', life: 3000 });
        }
    }, [axiosInstance, rolesLoaded]);

    useEffect(() => {
        if (EntidadNewDialog) {
            fetchRoles();
            fetchSucursales();
        }
    }, [EntidadNewDialog, fetchRoles, fetchSucursales]);

    const peticionGet = useCallback(async () => {
        try {
            const page = lazyParams.first / lazyParams.rows;
            const response = await axiosInstance.get('/api/usuario/', {
                params: {
                    page,
                    size: lazyParams.rows,
                    search: globalFilter || ''
                }
            });
            setData((response.data.content || []).map(mapUserFromApi));
            setTotalRecords(response.data.totalElements);
        } catch (error) {
            console.error(error);
        } finally {
        }
    }, [lazyParams, globalFilter, axiosInstance]);

    const peticionPost = async () => {
        try {
            // Crear payload solo con campos válidos del UserRequest DTO
            const selectedRoleObj = roles.find(r => r.value === product.role);
            
            const payload = {
                username: product.username,
                password: product.docIdentidad, // Por defecto es el DNI
                nombres: product.nombres,
                apellidoPaterno: product.apellidoPaterno || '',
                apellidoMaterno: product.apellidoMaterno || '',
                email: product.email,
                telefono: product.telefono,
                tipoDocumento: product.tipoDocumento || 'DNI',
                numeroDocumento: product.docIdentidad,
                idSucursal: product.idSucursal,
                profileId: selectedRoleObj ? selectedRoleObj.id : null
            };

            // CRÍTICO: Si no hay rol, no guardar el usuario sin perfil
            if (!product.role) {
                console.error("CRÍTICO: Intento de crear usuario sin rol/perfil");
                toast.current.show({ severity: 'error', summary: 'Error Crítico', detail: 'Debe asignar un rol/perfil al usuario.', life: 5000 });
                return;
            }

            // Crear usuario primero
            const response = await axiosInstance.post('/api/usuario/', payload);
            const newUserId = response.data?.data?.id || response.data?.id;
            
            // Si hay rol seleccionado, asignar perfil al usuario creado
            if (newUserId && product.role) {
                try {
                    console.log(`Asignando perfil "${product.role}" al nuevo usuario ID: ${newUserId}`);
                    await axiosInstance.post('/api/usuario/asignar-perfil', {
                        userId: newUserId,                    // ✅ Parámetro correcto
                        newProfileName: product.role          // ✅ Parámetro correcto (nombre del perfil, no ID)
                    });
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Usuario Creado Correctamente', life: 3000 });
                } catch (profileError) {
                    console.error("❌ Error CRÍTICO al asignar perfil al nuevo usuario:", profileError);
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error Crítico', 
                        detail: 'Usuario creado pero no se pudo asignar el perfil. El usuario no podrá iniciar sesión.', 
                        life: 5000 
                    });
                }
            }

            peticionGet();
        } catch (error) {
            let errorMessage = 'Error al crear usuario';
            if (error.response) {
                if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                } else {
                    errorMessage = JSON.stringify(error.response.data);
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage, life: 5000 });
        }
    };

    const peticionPut = async () => {
        try {
            // Crear payload solo con campos válidos del UserRequest DTO
            const payload = {
                id: product.id,
                username: product.username,
                password: product.password || undefined, // Solo si se cambió
                nombres: product.nombres,
                apellidoPaterno: product.apellidoPaterno || '',
                apellidoMaterno: product.apellidoMaterno || '',
                email: product.email,
                telefono: product.telefono,
                tipoDocumento: product.tipoDocumento || 'DNI',
                numeroDocumento: product.docIdentidad || product.numeroDocumento || '',
                idSucursal: product.idSucursal
            };

            // Eliminar password si está vacío (para no forzar cambio de contraseña)
            if (!payload.password) {
                delete payload.password;
            }

            // Nota: En la actualización de usuario básico (PUT) no enviamos el profileId
            // porque el backend (UserRequest dto) no lo espera. El rol se cambia en saveProduct luego.

            let success = false;

            await axiosInstance.put('/api/usuario/', payload)
                .then(() => {
                    var dataNueva = data.map(u => {
                        if (u.id === product.id) {
                            u.username = product.username;
                            u.nombres = product.nombres;
                            u.apellidoPaterno = product.apellidoPaterno;
                            u.apellidoMaterno = product.apellidoMaterno;
                            u.telefono = product.telefono;
                            u.email = product.email;
                        }
                        return u;
                    });
                    setData(dataNueva);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Ingreso Modificado', life: 3000 });
                    success = true;
                })
                .catch(error => {
                    let errorMessage = 'Datos Incorrectos';
                    if (error.response && error.response.data) {
                        errorMessage = error.response.data.message || error.response.data || errorMessage;
                    }
                    toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage, life: 5000 });
                });
            
            return success;
        } catch (error) {
            // Error handling
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error en la solicitud', life: 5000 });
            return false;
        }
    };

    const peticionPutReiniciarPass = async (productData) => {
        const payload = { id: productData.id };

        await axiosInstance.post('/api/usuario/passgenerico', payload)
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Contraseña Restaurada Correctamente', life: 3000 });
            }).catch(error => {
                let errorMessage = 'Datos Incorrectos';
                if (error.response && error.response.data) {
                    errorMessage = error.response.data.message || error.response.data || errorMessage;
                }
                toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage, life: 5000 });
            })
    }

    const peticionRENIEC = async () => {
        try {
            // console.log(`📡 Consultando RENIEC para DNI: ${product.docIdentidad}`);
            const response = await axiosInstance.get(`/api/reniec/consulta/${product.docIdentidad}`);
            
            if (response.status === 200 && response.data) {
                const nombres = response.data.nombres;
                // console.log(`✅ RENIEC - Datos obtenidos exitosamente`);
                setProduct((prevProduct) => ({
                    ...prevProduct,
                    nombres: nombres,
                    apellidoPaterno: response.data.apellidoPaterno || '',
                    apellidoMaterno: response.data.apellidoMaterno || '',
                }));
                toast.current.show({ 
                    severity: 'success', 
                    summary: 'RENIEC', 
                    detail: 'Datos del DNI obtenidos correctamente.', 
                    life: 3000 
                });
            }
        } catch (error) {
            // console.error("❌ Error al consultar RENIEC:", error);
            
            let errorDetail = 'No se pudo obtener la información del DNI.';
            
            if (error.response) {
                const status = error.response.status;
                const data = error.response.data;
                
                if (status === 400) {
                    errorDetail = data?.message || 'El DNI ingresado no tiene un formato válido. Debe tener 8 dígitos.';
                } else if (status === 404) {
                    errorDetail = data?.message || 'El DNI no se encontró en los registros de RENIEC.';
                } else if (status === 401) {
                    errorDetail = 'Error de autenticación con el servicio de RENIEC. Contacte al administrador.';
                } else if (status === 500 || status === 503) {
                    errorDetail = data?.message || 'El servicio de RENIEC no está disponible. Intente más tarde.';
                } else {
                    errorDetail = data?.message || `Error del servidor: ${status}`;
                }
            } else if (error.message === 'Network Error') {
                errorDetail = 'Error de red. Verifique su conexión a internet.';
            }
            
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error de RENIEC', 
                detail: errorDetail, 
                life: 5000 
            });
        }
    }

    const onPage = (event) => {
        setLazyParams((prevState) => ({
            ...prevState,
            first: event.first,
            rows: event.rows
        }));
    };

    useEffect(() => {
        if (user) {
            peticionGet();
        }
    }, [lazyParams, globalFilter, user, peticionGet]);

    const BuscarDNI = () => {
        if (product.docIdentidad && product.docIdentidad.trim().length === 8) {
            peticionRENIEC();
        } else {
            toast.current.show({ severity: 'warn', summary: 'DNI Inválido', detail: 'El DNI debe tener 8 dígitos.', life: 3000 });
        }
    }

    const openNew = () => {
        setProduct(empty);
        setSubmitted(false);
        setEntidadNewDialog(true);
    }
    const hideDialogNew = () => {
        setSubmitted(false);
        setEntidadNewDialog(false);
    }
    const editProduct = (product) => {
        // Inferir tipo de documento basado en la longitud si no existe en la base de datos
        let tipo = 'DNI';
        const documento = product.docIdentidad || product.numeroDocumento || '';
        if (documento && documento.length > 8) {
            tipo = 'CE';
        }
        // IMPORTANTE: Siempre asegurar que el role/profile se cargue del usuario existente
        // Esto previene que se pierda el perfil durante la edición
        const userRole = product.profile?.name || product.role;
        if (!userRole) {
            console.warn('⚠️ ADVERTENCIA: Usuario sin perfil/role asignado. ID:', product.id);
        }
        setProduct({
            ...product,
            docIdentidad: documento,
            apellidoPaterno: product.apellidoPaterno || '',
            apellidoMaterno: product.apellidoMaterno || '',
            role: userRole,
            tipoDocumento: product.tipoDocumento || tipo
        });
        setEntidadNewDialog(true);
    }

    const restaurarPass = (product) => {
        setProduct({ ...product });
        peticionPutReiniciarPass(product);
    }

    const saveProduct = async () => {
        setSubmitted(true);

        const isCreate = !product.id;

        // Validación estricta de DNI
        if (product.tipoDocumento === 'DNI' && product.docIdentidad && product.docIdentidad.length !== 8) {
            toast.current.show({
                severity: 'error',
                summary: 'DNI Inválido',
                detail: 'El DNI debe tener exactamente 8 dígitos para ser procesado.',
                life: 3000
            });
            return;
        }

        if (product.telefono && !/^\d{9}$/.test(product.telefono)) {
            toast.current.show({ severity: 'error', summary: 'Teléfono inválido', detail: 'El teléfono debe tener 9 dígitos.', life: 3000 });
            return;
        }

        if (isCreate && !product.docIdentidad) {
            toast.current.show({ severity: 'error', summary: 'Documento requerido', detail: 'Debe ingresar un documento para crear el usuario.', life: 3000 });
            return;
        }

        if (((isCreate && product.docIdentidad) || !isCreate) && product.username && product.nombres && product.apellidoPaterno && product.apellidoMaterno && product.email && product.telefono) {

            if (product.id) {
                // Actualizar Datos Básicos
                const putSuccess = await peticionPut();
                if (!putSuccess) return;

                // PREVENT FAILURES: Si el usuario se editó a SI MISMO y cambió su username o contraseña, 
                // su token JWT actualizó y las siguientes peticiones tirarán error 403 Forbidden.
                // Lo obligamos a desloguearse antes de que todo falle.
                if (user && user.id === product.id && (product.username !== user.username || product.password)) {
                    toast.current.show({ severity: 'warn', summary: 'Sesión Finalizada', detail: 'Has modificado tus propias credenciales. Por seguridad, inicia sesión nuevamente.', life: 5000 });
                    setTimeout(() => {
                        logout();
                    }, 2500);
                    return; // Detenemos la ejecución extra (asignar perfil/get) para prevenir el error 403
                }

                // CRÍTICO: SIEMPRE actualizar el Rol después de editar usuario
                // Esto previene que el usuario pierda su perfil/role durante la edición
                if (product.role) {
                    try {
                        console.log(`Asignando perfil "${product.role}" al usuario ID: ${product.id}`);
                        await axiosInstance.post('/api/usuario/asignar-perfil', { userId: product.id, newProfileName: product.role });
                        toast.current.show({ severity: 'success', summary: 'Perfil Actualizado', detail: `Rol "${product.role}" asignado correctamente.`, life: 3000 });
                    } catch (error) {
                        console.error("❌ Error crítico al asignar perfil:", error);
                        let errorMsg = "No se pudo actualizar el rol. El usuario podría quedar sin perfil.";
                        if (error.response && error.response.data && error.response.data.message) {
                            errorMsg = error.response.data.message;
                        }
                        toast.current.show({ severity: 'error', summary: 'Error de Permisos', detail: errorMsg, life: 5000 });
                    }
                } else {
                    // ALERTA: Si no hay role, mostrar error y no guardar cambios
                    console.error("❌ CRÍTICO: Usuario sin role definido. No se pueden guardar cambios.");
                    toast.current.show({ severity: 'error', summary: 'Error Crítico', detail: 'El usuario no tiene un rol/perfil asignado. Contacte al administrador.', life: 5000 });
                    return;
                }

                peticionGet(); // Refrescar lista completa
            }
            else {
                await peticionPost();
                // peticionPost ya llama a peticionGet
            }
            setEntidadNewDialog(false);
            setProduct(empty);
        }
    }


    const exportCSV = () => {
        // dt.current.exportCSV();
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = { ...product };
        _product[`${name}`] = val;

        // Si cambiamos el tipo de documento, reseteamos el número para evitar inconsistencias
        if (name === 'tipoDocumento') {
            _product.docIdentidad = '';
        }

        setProduct(_product);
    }

    // Only allow numeric input for DNI and phone fields
    const onNumericInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        const numericVal = val.replace(/[^0-9]/g, '');
        let _product = { ...product };
        _product[`${name}`] = numericVal;
        setProduct(_product);
    }

    const onRoleChange = (e) => {
        let _product = { ...product };
        _product['role'] = e.value;
        setProduct(_product);
    }

    const idBody = (rowData) => {
        return (
            <>
                {rowData.numeroDocumento || rowData.docIdentidad}
            </>
        );
    }

    const usernameBody = (rowData) => {
        return (
            <>
                {rowData.username}
            </>
        );
    }

    const nombreBody = (rowData) => {
        return (
            <>
                {rowData.nombres + ' ' + (rowData.apellidoPaterno || '') + ' ' + (rowData.apellidoMaterno || '')}
            </>
        );
    }

    const emailBody = (rowData) => {
        return (
            <>
                {rowData.email}
            </>
        );
    }

    const telefonoBody = (rowData) => {
        return (
            <>
                {rowData.telefono}
            </>
        );
    }

    const deleteUser = (rowData) => {
        if (rowData.role === 'SUPER_ADMINISTRADOR' || rowData.profile?.name === 'SUPER_ADMINISTRADOR') {
            toast.current.show({ severity: 'warn', summary: 'Acción no permitida', detail: 'No se puede eliminar un SUPER_ADMINISTRADOR.', life: 4000 });
            return;
        }

        confirmDialog({
            message: `¿Está seguro de eliminar al usuario "${rowData.nombres} ${rowData.apellidoPaterno || ''} ${rowData.apellidoMaterno || ''}"?`,
            header: 'Confirmar Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            rejectClassName: 'p-button-outlined',
            acceptLabel: 'Sí, eliminar',
            rejectLabel: 'No',
            accept: async () => {
                try {
                    await axiosInstance.delete(`/api/usuario/${rowData.id}`);
                    toast.current.show({ severity: 'success', summary: 'Eliminado', detail: `Usuario "${rowData.username}" eliminado correctamente.`, life: 3000 });
                    peticionGet();
                } catch (error) {
                    const message = error.response?.data?.message || 'No se pudo eliminar el usuario.';
                    toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 4000 });
                }
            }
        });
    };

    const actionBody = (rowData) => {
        return (
            <div className="action-buttons">
                <Button
                    icon="pi pi-pencil"
                    tooltip="Editar usuario"
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => editProduct(rowData)}
                    className="btn-edit"
                />
                <Button
                    icon="pi pi-refresh"
                    tooltip="Restaurar contraseña"
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => restaurarPass(rowData)}
                    className="btn-reset"
                />
                <Button
                    icon="pi pi-trash"
                    tooltip="Eliminar usuario"
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => deleteUser(rowData)}
                    className="btn-delete"
                />
            </div>
        );
    }

    return (
        <div className="grid crud-demo usuario-page">
            <div className="col-12">
                <PageHeader
                    title="Control de Usuarios"
                    description="Administra el acceso de personal"
                    icon="pi pi-users"
                />

                {/* Contenido principal */}
                <div className="main-content">
                    <div className="card shadow-2 border-round-xl">
                        <ConfirmDialog />
                        <Toast ref={toast} />

                        <ActionToolbar
                            onNew={openNew}
                            newLabel="Nuevo Usuario"
                            onSearch={(val) => {
                                setGlobalFilter(val);
                            }}
                            searchValue={globalFilter}
                            searchPlaceholder="Buscar usuarios..."
                            extraActions={null}
                        />

                        <DataTable ref={dt} value={data} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="id"
                            paginator
                            lazy
                            resizableColumns
                            size='small'
                            first={lazyParams.first}
                            rows={lazyParams.rows}
                            totalRecords={totalRecords}
                            onPage={onPage}
                            loading={false}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} usuarios"
                            emptyMessage="No se encontraron usuarios."
                        >
                            <Column field="id" header="Documento" body={idBody} style={{ minWidth: '120px' }}></Column>
                            <Column field="nombre" header="Nombre Completo" body={nombreBody} style={{ minWidth: '220px' }}></Column>
                            <Column field="username" header="Usuario" body={usernameBody} style={{ minWidth: '150px' }}></Column>
                            <Column field="email" header="Correo Electrónico" body={emailBody} style={{ minWidth: '200px' }}></Column>
                            <Column field="telefono" header="Teléfono" body={telefonoBody} style={{ minWidth: '130px' }}></Column>
                            <Column header="Acciones" body={actionBody} style={{ minWidth: '120px', textAlign: 'center' }}></Column>
                        </DataTable>
                    </div>
                </div>

                <Dialog
                    visible={EntidadNewDialog}
                    style={{ width: '800px', maxWidth: '95vw' }}
                    header={
                        <DialogHeader
                            title={product.id ? 'Editar Usuario' : 'Nuevo Usuario'}
                            subtitle={product.id ? 'Modificar datos del usuario' : 'Registrar un nuevo usuario'}
                            icon="pi pi-user-plus"
                        />
                    }
                    modal
                    className="p-fluid custom-profile-dialog"
                    footer={
                        <div className="dialog-footer-buttons">
                            <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={hideDialogNew} />
                            <Button label="Guardar" icon="pi pi-check" onClick={saveProduct} autoFocus />
                        </div>
                    }
                    onHide={hideDialogNew}
                >
                    <div className="formgrid grid mt-4 dialog-content-specific">
                        <div className="field col-12 md:col-6">
                            <label htmlFor="tipoDocumento">Tipo de Documento</label>
                            <Dropdown
                                id="tipoDocumento"
                                value={product.tipoDocumento || 'DNI'}
                                options={[
                                    { label: 'DNI', value: 'DNI' },
                                    { label: 'Carnet de Extranjería', value: 'CE' }
                                ]}
                                onChange={(e) => onInputChange(e, 'tipoDocumento')}
                                placeholder="Seleccione tipo"
                            />
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="docIdentidad">{product.tipoDocumento === 'CE' ? 'Carnet de Extranjería' : 'DNI'}</label>
                            <div className={product.tipoDocumento === 'CE' ? '' : 'p-inputgroup'}>
                                <InputText
                                    id="docIdentidad"
                                    value={product.docIdentidad}
                                    onChange={(e) => onNumericInputChange(e, 'docIdentidad')}
                                    required={!product.id}
                                    disabled={!!product.id}
                                    placeholder={product.tipoDocumento === 'CE' ? 'Ingrese Carnet' : 'Ingrese DNI'}
                                    maxLength={product.tipoDocumento === 'CE' ? 12 : 8}
                                    className={classNames({ 'p-invalid': submitted && !product.docIdentidad })}
                                />
                                {product.tipoDocumento !== 'CE' && (
                                    <Button icon="pi pi-search" onClick={BuscarDNI} tooltip="Consultar RENIEC" className="btn-search-dni-specific" />
                                )}
                            </div>
                            {submitted && !product.docIdentidad && <small className="p-error">El documento es requerido.</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="username">Usuario</label>
                            <InputText
                                id="username"
                                value={product.username}
                                onChange={(e) => onInputChange(e, 'username')}
                                required
                                placeholder="Nombre de usuario"
                                className={classNames({ 'p-invalid': submitted && !product.username })}
                            />
                            {submitted && !product.username && <small className="p-error">El usuario es requerido.</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="nombres">Nombres</label>
                            <InputText
                                id="nombres"
                                value={product.nombres}
                                onChange={(e) => onInputChange(e, 'nombres')}
                                required
                                placeholder="Nombres completos"
                                className={classNames({ 'p-invalid': submitted && !product.nombres })}
                            />
                            {submitted && !product.nombres && <small className="p-error">Nombres requeridos.</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="apellidoPaterno">Apellido Paterno</label>
                            <InputText
                                id="apellidoPaterno"
                                value={product.apellidoPaterno || ''}
                                onChange={(e) => onInputChange(e, 'apellidoPaterno')}
                                required
                                placeholder="Apellido paterno"
                                className={classNames({ 'p-invalid': submitted && !product.apellidoPaterno })}
                            />
                            {submitted && !product.apellidoPaterno && <small className="p-error">Apellido paterno requerido.</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="apellidoMaterno">Apellido Materno</label>
                            <InputText
                                id="apellidoMaterno"
                                value={product.apellidoMaterno || ''}
                                onChange={(e) => onInputChange(e, 'apellidoMaterno')}
                                required
                                placeholder="Apellido materno"
                                className={classNames({ 'p-invalid': submitted && !product.apellidoMaterno })}
                            />
                            {submitted && !product.apellidoMaterno && <small className="p-error">Apellido materno requerido.</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="email">Correo Electrónico</label>
                            <InputText
                                id="email"
                                value={product.email}
                                onChange={(e) => onInputChange(e, 'email')}
                                required
                                placeholder="ejemplo@correo.com"
                                className={classNames({ 'p-invalid': submitted && !product.email })}
                            />
                            {submitted && !product.email && <small className="p-error">Correo requerido.</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="telefono">Teléfono</label>
                            <InputText
                                id="telefono"
                                value={product.telefono}
                                onChange={(e) => onNumericInputChange(e, 'telefono')}
                                required
                                maxLength={9}
                                placeholder="Ingrese teléfono"
                                className={classNames({ 'p-invalid': submitted && !product.telefono })}
                            />
                            {submitted && !product.telefono && <small className="p-error">Teléfono requerido.</small>}
                        </div>

                        <div className="field col-12">
                            <label htmlFor="role">Rol de Usuario</label>
                            <Dropdown
                                id="role"
                                value={product.role}
                                options={roles}
                                onChange={onRoleChange}
                                optionLabel="label"
                                placeholder="Seleccione un Rol"
                                className="w-full"
                            />
                        </div>

                        <div className="field col-12">
                            <label htmlFor="idSucursal">Sucursal Asignada</label>
                            <Dropdown
                                id="idSucursal"
                                value={product.idSucursal}
                                options={sucursales}
                                onChange={(e) => onInputChange(e, 'idSucursal')}
                                optionLabel="label"
                                placeholder="Multi-sucursal (Todas las sucursales)"
                                showClear
                                className="w-full"
                            />
                            <small className="block mt-1 text-500">Deje en blanco para designar acceso a todas las sucursales (ej: super admins, gerentes).</small>
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    );
};
export default Usuario;
